// Module
var code = "<article-tags></article-tags>\n";
// Exports
module.exports = code;